//接口域名地址
let baseURL, protocol = 'https://', legislation = '',
    hostName = '';
if (process.env.NODE_ENV === 'development') {
    hostName = process.env.VUE_APP_HOSTNAME_TEST
    legislation = 'https://testonekb-retrieval.odrcloud.cn'
} else if (process.env.NODE_ENV === 'production') {
    if (process.env.VUE_APP_TYPE === "test") {
        hostName = process.env.VUE_APP_HOSTNAME_TEST
        legislation = 'https://testonekb-retrieval.odrcloud.cn'
    } else if (process.env.VUE_APP_TYPE === 'prod') {
        hostName = process.env.VUE_APP_HOSTNAME_PROD;
        legislation = 'https://onekb-retrieval.odrcloud.cn'
    } else {
        hostName = process.env.VUE_APP_HOSTNAME_TEST
        legislation = 'https://testonekb-retrieval.odrcloud.cn'
    }
}
baseURL = protocol + hostName

export default {
    baseURL: baseURL,
    hostName: hostName,
    legislationUrl: legislation
}